import { useMutation } from '@tanstack/react-query';

import {
  updateProductImage,
  UpdateProductImagePayload
} from '../api/updateProductImage';

export const useUpdateProductImage = () => {
  return useMutation({
    mutationFn: async (payload: UpdateProductImagePayload) => {
      return await updateProductImage(payload);
    }
  });
};
